import { render, staticRenderFns } from "./DashboardList.vue?vue&type=template&id=54d8481e&"
import script from "./DashboardList.vue?vue&type=script&lang=js&"
export * from "./DashboardList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardList.vue?vue&type=style&index=0&id=54d8481e&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d8481e')) {
      api.createRecord('54d8481e', component.options)
    } else {
      api.reload('54d8481e', component.options)
    }
    module.hot.accept("./DashboardList.vue?vue&type=template&id=54d8481e&", function () {
      api.rerender('54d8481e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/dashboardComponents/DashboardList.vue"
export default component.exports